// pdfViewSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { BASE_FILEURL } from '../components/constants';

export const fetchPDF = createAsyncThunk(
  'pdfViewer/fetchPDF',
  async ({ userId, taskId, filename, historyId }) => {
    const response = await fetch(`${BASE_FILEURL}/getfile`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ user_id: userId, task_id: taskId, filename,history_id: historyId }),
    });

    if (!response.ok) {
      throw new Error('Failed to fetch PDF');
    }

    const blob = await response.blob();
    return blob;
  }
);

const pdfViewerSlice = createSlice({
  name: 'pdfViewer',
  initialState: {
    pdfUrl: null,
    loading: false,
    error: null,
  },
  reducers: {
    resetPdfUrl: (state) => {
      state.pdfUrl = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPDF.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPDF.fulfilled, (state, action) => {
        state.loading = false;
        state.pdfUrl = action.payload;
      })
      .addCase(fetchPDF.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { resetPdfUrl } = pdfViewerSlice.actions;
export default pdfViewerSlice.reducer;